import type { WWindowBannerTranslations } from "./pl";

export const de: WWindowBannerTranslations = {
  empty: "Keine Banner zum Anzeigen.",
  goToSlide: (index: number): string => `Zum Banner ${index} wechseln`,
  bannerAlt: "Banner",
  close: "Schließen",
};
